import { css } from '@emotion/react';

export const separator = css`
  font-size: var(--font-size-2);
  line-height: var(--line-height-2);
  color: var(--gray-9);
`;
